// * Takes a hex value and changes it into an RGB value
export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
    hex.replace('#', '')
  );
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const getDate = (dateString) => {
  if (!dateString) return null;
  const arr = dateString.split('-');
  return `${months[arr[1] - 1]} ${arr[2]}, ${arr[0]}`;
};

export const camelToKebabCase = (str) =>
  str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

/**
 * Summary: extract video id from youtube links supports multiple formats
 * Description: used by embeded youtube player components
 * @param {string} str url in string format to extract url from
 * @returns id in string format
 * @author Abbas Khan
 * @date 2021/04/07
 */
export function getVideoId(str) {
  // if invalid return str
  if (str === (undefined || null)) return str;

  // remove any extra params such &t=1s
  const url = str.split('&')[0];

  // short url
  if (url.split('https://youtu.be/')[1])
    return url.split('https://youtu.be/')[1];

  // full url
  if (url.split('https://www.youtube.com/watch?v=')[1])
    return url.split('https://www.youtube.com/watch?v=')[1];

  // embeded url
  if (url.split('https://www.youtube.com/embed/')[1])
    return url.split('https://www.youtube.com/embed/')[1];

  // else return given string
  return str;
}
